export default "__VITE_ASSET__llbji6wz__"